export const GoogleMapApiConfig = 'AIzaSyCr8loVUmrKRNQvX_LJqBGTq9PQxLlVQZ4';